<template>
  <div class="content-body">
    <LanguageSelector/>
    <section id="basic-datatable">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-header">
                <h5 class="card-title">Manage Landlords</h5>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li v-if="!phoneFilter">
                      <button class="btn btn-primary" @click="findByPhoneModal()">
                        Find by Phone
                      </button>
                    </li>
                    <li v-else>
                      <button class="btn btn-danger" @click="getLandlords()">
                        Remove Phone Filter
                      </button>
                    </li>
                    <li>
                      <div class="has-icon-left">
                        <select class="form-control" v-model="genderFilter"
                                @change="filterByData()">
                          <option selected>All Genders...</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Private">Private</option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-user font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="has-icon-left">
                        <select class="form-control" v-model="countryFilter"
                                @change="filterByData()">
                          <option selected>All Countries...</option>
                          <option v-for="(country, index) in usersCountries" :value="country"
                                  :key="index">{{ countryName(country) }}
                          </option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-map font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="has-icon-left">
                        <input type="text" class="form-control" @keyup="searchInTable()"
                               v-model="searchInputText" placeholder="Search..."/>
                        <div class="form-control-position">
                          <em class="bx bx-search font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body card-dashboard">
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status" v-if="loadingData"
                       style="opacity: .6">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="text-center mt-1" v-if="!landlords.length && !loadingData">
                  <p>No Users Found...</p>
                </div>
                <div class="table-responsive" style="overflow-x: hidden;" v-if="landlords.length">

                  <table class="table zero-configuration nowrap  " id="infinite-list" :aria-label="$t('landlords_aria_label_landlord_list')">
                    <thead>
                    <tr>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Gender</th>
                      <th>City</th>
                      <th>Date of Birth</th>
                      <th>Created At</th>
                      <th>Country</th>
                      <th>Contract</th>
                      <th>Contacts</th>
                      <th>House</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(landlord, index) in landlords" :key="index">
                      <td class="landlordName" v-if="landlord.name">
                        <router-link class="text-bold-500"
                                     :to="{name: 'SingleUserPage', params: {uuid: landlord.uid} }">{{
                            landlord.name
                          }}
                        </router-link>
                        <br>
                        <a href="#" @click="editLandlordModal(landlord.uid)"
                           style="margin-top: 5px;"><em class="bx bx-edit-alt"></em> Edit</a>
                      </td>
                      <td v-else>
                        -
                        <br>
                        <a href="#" @click="editLandlordModal(landlord.uid)"
                           style="margin-top: 5px;"><em class="bx bx-edit-alt"></em> Edit</a>
                      </td>
                      <td v-if="landlord.status == 'banned'">
                        <em
                          class="bx bxs-circle danger font-small-1 mr-50"></em><span>Banned</span>
                      </td>
                      <td v-else>
                        <em
                          class="bx bxs-circle success font-small-1 mr-50"></em><span>Active</span>
                      </td>
                      <td v-if="landlord.gender" class="capitalize">{{ landlord.gender }}</td>
                      <td v-else>-</td>
                      <td v-if="landlord.address.city">{{ landlord.address.city }}</td>
                      <td v-else>-</td>
                      <td v-if="landlord.dob">{{ landlord.dob.split('T')[0] }}</td>
                      <td v-else>-</td>
                      <td>{{ landlord.createdAt.split('T')[0] }}</td>
                      <td v-if="landlord.currentCountry">{{
                          countryName(landlord.currentCountry)
                        }}
                      </td>
                      <td v-else>-</td>
                      <td>-</td>
                      <td>
                        <span v-if="landlord.phoneNumber">{{ landlord.phoneNumber }}</span>
                        <span v-else>-</span>
                        <br>
                        <span v-if="landlord.email">{{ landlord.email }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>-</td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>

          </div>
          <div class="text-center">
            <div class="spinner-border text-primary" role="status"
                 style="opacity: .6" :class="{ invisible: !loadingSpinner }">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Find by Phone Modal -->
    <div class="modal fade text-left" id="find-by-phone-modal" tabindex="-1" role="dialog"
         aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Insert Phone Number</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input type="tel" id="phoneNumber" class="form-control" v-model="phoneNumberTarget">
            </div>
            <div class="text-center">
              <button type="button" class="btn btn-primary" @click="findByPhone()">
                <em class="bx bx-check d-block d-sm-none"></em>
                <span class="d-none d-sm-block">Search</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Landlord Modal -->
    <div class="modal fade text-left" id="edit-landlord-modal" tabindex="-1" role="dialog"
         aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">Edit Landlord</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert :text="deleteUserErrorText" type="danger" dismissable="false"
                   v-if="deleteUserErrorText != ''"/>
            <Alert :text="banUserErrorText" type="danger" dismissable="false"
                   v-if="banUserErrorText != ''"/>
            <form action="#">
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for="">Name</label>
                  <input type="text" class="form-control" v-model="nameEdit">
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for="">Date of Birth</label>
                  <div class="form-group position-relative has-icon-left">
                    <input type="text" class="form-control" placeholder="Select Date" id="dob-input"
                           v-model="dobEdit">
                    <div class="form-control-position">
                      <em class='bx bx-calendar'></em>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for="">Current Country</label>
                  <select class="form-control" v-model="currentCountryEdit">
                    <option v-for="(aC, index) in activeCountries" :key="index"
                            :value="aC.toLowerCase()">{{ countryName(aC) }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for="">Gender</label>
                  <select class="form-control" v-model="genderEdit">
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="private">Private</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for="">Street</label>
                  <input type="text" class="form-control" v-model="addressStreetEdit">
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for="">Additional</label>
                  <input type="text" class="form-control" v-model="addressAdditionalEdit">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for="">City</label>
                  <input type="text" class="form-control" v-model="addressCityEdit">
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for="">ZIP</label>
                  <input type="text" class="form-control" v-model="addressZipEdit">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for="">Description</label>
                  <textarea class="form-control" rows="6" v-model="addressDescriptionEdit"></textarea>
                </div>
              </div>
              <p class="text-muted">
                Last edited by: <strong>{{ lastEditedBy }}</strong>
              </p>
            </form>
            <div class="text-left">
              <button class="btn btn-danger" @click="banUser(targetEdit.uid)"
                      v-if="targetEdit.status != 'banned'">
                Ban User
              </button>
              <button class="btn btn-success" @click="unbanUser(targetEdit.uid)" v-else>
                Unban User
              </button>
              <button class="btn btn-danger"
                      v-if="(targetEdit.contracts && !targetEdit.contracts.length || !targetEdit.contracts) && (targetEdit.contractProposals && !targetEdit.contractProposals.length || !targetEdit.contractProposals) && (targetEdit.properties && !targetEdit.properties.length || !targetEdit.properties)"
                      @click="deleteLandlord(targetEdit.uid)">
                Delete User
              </button>
              <button class="btn btn-danger" v-if="targetEdit.contracts && targetEdit.contracts.length"
                      @click="deleteData(targetEdit.contracts, 'contracts')">
                Delete Contracts
              </button>
              <button class="btn btn-danger"
                      v-if="(targetEdit.contracts && !targetEdit.contracts.length || !targetEdit.contracts) && targetEdit.contractProposals && targetEdit.contractProposals.length"
                      @click="deleteData(targetEdit.contractProposals, 'proposals')">
                Delete Proposals
              </button>
              <button class="btn btn-danger"
                      v-if="(targetEdit.contractProposals && !targetEdit.contractProposals.length || !targetEdit.contractProposals) && targetEdit.properties && targetEdit.properties.length"
                      @click="deleteData(targetEdit.properties, 'properties')">
                Delete Properties
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">Close</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="editLandlord(targetEdit.uid)">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">Save Changes</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/app-assets/js/scripts/extensions/ext-component-block-ui.js'
import {getCountryName} from '@/app-assets/js/get-countries.js'
import Alert from "@/components/Alerts";

export default {
  data() {
    return {
      landlords: [],
      usersCountries: [],
      countryFilter: 'All Countries...',
      genderFilter: 'All Genders...',
      activeCountries: [],
      loadingData: true,
      loadingSpinner: false,
      dataloaded: false,
      searchInputText: '',
      targetEdit: [],
      nameEdit: '',
      addressAdditionalEdit: '',
      addressStreetEdit: '',
      addressCityEdit: '',
      addressZipEdit: '',
      addressDescriptionEdit: '',
      currentCountryEdit: '',
      genderEdit: '',
      dobEdit: '',
      lastEditedBy: '-',
      phoneNumberObj: null,
      phoneNumberTarget: '',
      phoneFilter: false,
      deleteUserErrorText: "",
      banUserErrorText: "",
      busy: false,
      limit: 10,
      lastUid: 0,
      apiUrl: ``,
      scrolling: false,
      append: [],
      scrollTimer: null,
      dTable: null
    }
  },

  components: {
    Alert
  },

  methods: {

    deleteData(data, type) {
      var promiseURI = [];
      var block_ele = $("#edit-landlord-modal .modal-content")
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent'
        }
      });
      switch (type) {
        case 'contracts': {
          data.map(x => {
            promiseURI.push(this.$apiCall.delete(`/v1/contracts/contract/${x}`));
          })
          break;
        }
        case 'proposals': {
          data.map(x => {
            promiseURI.push(this.$apiCall.delete(`/v1/contracts/proposals/${x}?deleteInvites=true`));
          })
          break;
        }
        case 'properties': {
          data.map(x => {
            promiseURI.push(this.$apiCall.delete(`/v1/properties/${x}`));
          })
          break;
        }
      }


      Promise.all(promiseURI)
        .then(response => {
          this.editLandlordModal(this.targetEdit.uid, 'delete')
        })
        .catch(error => {
          $(block_ele).unblock()
        })
    },

    editLandlordModal(uid, from = 'table') {
      this.deleteUserErrorText = ""
      if (from == 'table') {
        $.blockUI({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: 'wait'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'transparent'
          }
        })
      } else {
        var block_ele = $("#edit-landlord-modal .modal-content")
      }
      let self = this
      this.$apiCall.get(`/v1/users/${uid}`)
        .then(response => {
          console.log(response);
          $.unblockUI()
          self.targetEdit = response.data
          self.nameEdit = self.targetEdit.name
          self.addressAdditionalEdit = self.targetEdit.address.additional
          self.addressStreetEdit = self.targetEdit.address.street
          self.addressCityEdit = self.targetEdit.address.city
          self.addressZipEdit = self.targetEdit.address.zip
          self.addressDescriptionEdit = self.targetEdit.address.description
          self.currentCountryEdit = ((self.targetEdit.currentCountry) ? self.targetEdit.currentCountry : 'lb')
          self.genderEdit = ((self.targetEdit.gender) ? self.targetEdit.gender : 'male')
          self.lastEditedBy = (self.targetEdit.lastEditedBy.name) ? self.targetEdit.lastEditedBy.name : '-'
          let dob = ''
          if (self.targetEdit.dob) {
            dob = self.targetEdit.dob.split('T')[0].split('-')
            dob = `${dob[1]}/${dob[2]}/${dob[0]}`
          }
          self.dobEdit = dob

          //DOB Input
          const pD = $("#dob-input").pickadate({
            format: 'mm/dd/yyyy',
            selectYears: 200,
            selectMonths: true
          });

          if (from == 'table') {
            $("#edit-landlord-modal").modal()
          } else {
            $(block_ele).unblock()
          }
        })
    },

    editLandlord(uid) {
      let self = this
      var block_ele = $("#edit-landlord-modal .modal-content")
      this.deleteUserErrorText = ""
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent'
        }
      });
      let newDob = $("#dob-input").val().split('/')
      newDob = `${newDob[2]}-${newDob[0]}-${newDob[1]}T00:00Z`
      this.$apiCall.patch(`/v1/users/${uid}`, {
        "name": self.nameEdit,
        "address": {
          "street": self.addressStreetEdit,
          "additional": self.addressAdditionalEdit,
          "city": self.addressCityEdit,
          "zip": self.addressZipEdit,
          "description": self.addressDescriptionEdit
        },
        "dob": newDob,
        "currentCountry": self.currentCountryEdit,
        "gender": self.genderEdit
      })
        .then(response => {
          $(block_ele).unblock()
          $("#edit-landlord-modal").modal('hide')
          self.landlords = []
          self.getLandlords()
        })
        .catch(error => {
          $.unblockUI()
          $(block_ele).unblock()
          this.deleteUserErrorText = `<strong>Ops!</strong> ${error.response.data.message}`
        })
    },

    banUser(uid) {
      let self = this
      this.banUserErrorText = "";
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent'
        }
      })
      this.$apiCall.post(`/v1/users/${uid}/ban`)
        .then(response => {
          $.unblockUI()
          $("#edit-landlord-modal").modal('hide')
          self.landlords = []
          self.getLandlords()
        })
        .catch(error => {
          $.unblockUI()
          this.banUserErrorText = `<strong>Ops!</strong> ${error.response.data.message}`
        })
    },

    unbanUser(uid) {
      let self = this
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent'
        }
      })
      this.$apiCall.post(`/v1/users/${uid}/unban`)
        .then(response => {
          $.unblockUI()
          $("#edit-landlord-modal").modal('hide')
          self.landlords = []
          self.getLandlords()
        })
    },

    deleteLandlord(uid) {
      let self = this
      this.deleteUserErrorText = ""
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent'
        }
      })
      this.$apiCall.delete(`/v1/users/${uid}`)
        .then(response => {
          $.unblockUI()
          $("#edit-landlord-modal").modal('hide')
          self.landlords = []
          self.getLandlords()
        })
        .catch(error => {
          $.unblockUI()
          this.deleteUserErrorText = `<strong>Ops!</strong> ${error.response.data.message}`
        })
    },

    initDataTable() {
      let self = this
      setTimeout(function () {
        if (self.dTable === null) {
          self.dTable = $('.zero-configuration').DataTable({
            "scrollX": true,
            scrollCollapse: true,
            "bLengthChange": false,
            "bFilter": false,
            "order": [],
            "paging": false,
            "info": false
          });
        }
      }, 100)
    },

    searchInTable() {
      var value = this.searchInputText.toLowerCase();
      $(".zero-configuration > tbody tr").filter(function () {
        $(this).toggle($(this).find('.landlordName').text().toLowerCase().indexOf(value) > -1)
      });
    },

    getLandlords() {
      let self = this
      self.phoneFilter = false
      self.loadingData = true
      self.loadingSpinner = false
      if (self.lastUid) {
        self.apiUrl = `/v1/users?type=landlord&startAfter=${self.lastUid}&pagelen=${self.limit}`
        self.loadingSpinner = true
      } else {
        self.apiUrl = `/v1/users?type=landlord&pagelen=${self.limit}`
      }
      this.$apiCall.get(self.apiUrl)
        .then(response => {
          self.loadingData = false;
          if (!response.data.data.length) {
            self.dataloaded = true;
            self.loadingSpinner = false;
          } else {
            self.dataloaded = false;
            self.append = response.data.data
            if (self.append.length) {
              response.data.data.forEach(function (element) {
                if (!self.usersCountries.includes(element.currentCountry) && element.currentCountry) {
                  self.usersCountries.push(element.currentCountry)
                }
              })
              self.landlords = [...self.landlords, ...self.append]
              self.initDataTable()
              self.lastUid = self.append[self.append.length - 1].uid;
            }
          }
        })
    },


    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase())
      }
    },

    filterApiCall(data) {
      let self = this;
      self.$apiCall
        .get(`/v1/users?type=landlord&${data}`)
        .then(response => {
          self.loadingData = false;
          self.landlords = response.data.data;
          self.initDataTable();
        })
    },
    filterByData() {
      let self = this;
      self.landlords = [];
      let filterValue = ""
      self.loadingData = true;
      let data = [];
      if (self.countryFilter != "All Countries...") {
        data.push("country=" + self.countryFilter)
      }
      if (self.genderFilter != "All Genders...") {
        data.push("gender=" + self.genderFilter.toLowerCase())
      }
      let query = '';
      if (data.length) {
        query = data.join('&');
        self.filterApiCall(query)
      } else {
        self.landlords = []
        self.usersCountries = [];
        self.getLandlords();
      }
    },

    getActiveCountries() {
      const countries = localStorage.getItem('activeCountries');

      this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
    },

    findByPhoneModal() {
      $("#find-by-phone-modal").modal()
    },

    initTelInput() {
      let input = document.querySelector("#phoneNumber")
      this.phoneNumberObj = intlTelInput(input)
    },

    findByPhone() {
      let self = this
      let countryData = this.phoneNumberObj.getSelectedCountryData()
      let pN = '%2B' + countryData.dialCode + this.phoneNumberTarget.replace(`+${countryData.dialCode}`, "")
      self.landlords = []
      self.loadingData = true
      self.phoneFilter = true
      $("#find-by-phone-modal").modal('hide')
      this.$apiCall.get(`/v1/users/phone/${pN}`)
        .then(response => {
          if (response.data.type === 'landlord') {
            self.landlords.push(response.data)
          } else {
            self.landlords = []
          }
          self.phoneNumberTarget = ''
          self.loadingData = false
          self.initDataTable()
        })
        .catch(error => {
          self.phoneNumberTarget = ''
          self.loadingData = false
          self.initDataTable()
        })
    },
    handleScroll() {
      let self = this;
      self.scrolling = true;
      if (self.scrollTimer) {
        clearTimeout(self.scrollTimer)
      }
      self.scrollTimer = setTimeout(function () {

        var scrollHeight = $(document).height();
        var scrollPosition = $(window).height() + $(window).scrollTop();

        if ((scrollHeight - scrollPosition) < 20) {
          if (self.dataloaded === false) {
            self.getLandlords()
            self.scrolling = false;
          }
        } else {
          self.dataloaded = false;
        }
      }, 1000)
    },
  },

  watch: {
    phoneNumberTarget: function (value) {
      this.phoneNumberTarget = value.replace(/[^\d|\-+]/g, '')
    }
  },

  mounted() {

    this.getLandlords()
    this.getActiveCountries()
    this.initTelInput()
    if (navigator.appVersion.indexOf("Chrome/") != -1) {
      $("li > .btn.btn-primary").addClass("mt-chrome")
    } else {
      $("li > .btn.btn-primary").addClass("mt-firefox")
    }
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

}
</script>

<style scoped>
.zero-configuration td {
  white-space: nowrap;
}

.invisible {
  visibility: hidden;
}
.heading-elements .list-inline li {
  margin-right: 5px;
}
</style>
